import RuIcon from '@/public/langs/ru.svg'
import EnIcon from '@/public/langs/en.svg'
import ZhIcon from '@/public/langs/zh.svg'
import ArIcon from '@/public/langs/ar.svg'
import InIcon from '@/public/langs/in.svg'
import BrIcon from '@/public/langs/br.svg'
import FrIcon from '@/public/langs/fr.svg'
import FaIcon from '@/public/langs/fa.svg'
import FullEng from '@/public/brics-full-eng.svg'
import RoundEng from '@/public/brics-round-eng.svg'
import LineEng from '@/public/brics-line-eng.svg'
import FullRu from '@/public/brics-full-ru.svg'
import RoundRu from '@/public/brics-full-ru.svg'
import LineRu from '@/public/brics-full-ru.svg'

export const SYMBOLS_STUB = [
  {
    logo: '/logo-type.svg',
  },
  {
    logo: '/symbols-eng.svg',
  },
]

export const LANGUAGES = [
  {
    label: 'Русский',
    locale: 'ru',
    icon: RuIcon,
  },
  {
    label: 'English',
    locale: 'en',
    icon: EnIcon,
  },
  {
    label: '汉语',
    locale: 'zh',
    icon: ZhIcon,
  },
  {
    label: 'Português',
    locale: 'pt',
    icon: BrIcon,
  },
  {
    label: 'Français',
    locale: 'fr',
    icon: FrIcon,
  },
  {
    label: 'اَلْعَرَبِيَّةُ',
    locale: 'ar',
    icon: ArIcon,
  },
  {
    label: 'Indonesia',
    locale: 'id',
    icon: InIcon,
  },
  {
    label: 'فارسی',
    locale: 'fa',
    icon: FaIcon,
  },
]

export const SYMBOLS = [
  {
    src: '/brics-full-eng.svg',
    alt: 'brics-full-eng',
    locale: 'en',
    downloadLink: 'brics-full-eng.svg',
  },
  {
    src: '/brics-round-eng.svg',
    alt: 'brics-round-eng',
    locale: 'en',
    downloadLink: 'brics-round-eng.svg',
  },
  {
    src: '/brics-line-eng.svg',
    alt: 'brics-line-eng',
    locale: 'en',
    downloadLink: 'brics-line-eng.svg',
  },
  {
    src: '/brics-full-ru.svg',
    alt: 'brics-full-ru',
    locale: 'ru',
    downloadLink: 'brics-full-ru.svg',
  },
  {
    src: '/brics-round-ru.svg',
    alt: 'brics-round-ru',
    locale: 'ru',
    downloadLink: 'brics-round-ru.svg',
  },
  {
    src: '/brics-line-ru.svg',
    alt: 'brics-line-ru',
    locale: 'ru',
    downloadLink: 'brics-line-ru.svg',
  },
]

export const SOURCES = [
  {
    text: 'Статья опубликована в <a href="https://cdn.brics-russia2024.ru/upload/docs/%D0%91%D0%A0%D0%98%D0%9A%D0%A1_2024.pdf?17187894874060127" target="_blank" rel="noopener">специальном выпуске журнала "Международная жизнь" - "Российское председательство в БРИКС - 2024: Укрепление многосторонности &nbsp;для справедливого &nbsp;глобального развития &nbsp;и безопасности"</a>, 2024',
  },
  {
    text: 'Статья опубликована в <a href="https://cdn.brics-russia2024.ru/upload/docs/%D0%91%D0%A0%D0%98%D0%9A%D0%A1_2024.pdf?17187894874060127" target="_blank" rel="noopener">специальном выпуске журнала "Международная жизнь" - "Российское председательство в БРИКС - 2024: Укрепление многосторонности &nbsp;для справедливого &nbsp;глобального развития &nbsp;и безопасности"</a>, 2024',
  },
]

export const YANDEX_METRIKA_ID = 99965612
